import { render, staticRenderFns } from "./PlanRenewalSwitchModal.vue?vue&type=template&id=20d1ee1e"
import script from "./PlanRenewalSwitchModal.vue?vue&type=script&lang=js"
export * from "./PlanRenewalSwitchModal.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/plan-renewal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports